import { createFileRoute } from '@tanstack/react-router';

import { NearlyDoneStep } from '@/features/onboarding/components/steps/nearlyDone/nearlyDoneStep';

export const Route = createFileRoute(
  '/_protected/onboarding/_steps/nearly-done',
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <NearlyDoneStep />;
}
